import React from 'react';
import { FiSearch, FiPlus, FiEdit, FiTrash2, FiPower } from 'react-icons/fi';
import Button from '../common/Button';

function ServicesTab({
  services,
  loading,
  searchTerm,
  categoryFilter,
  onSearchChange,
  onCategoryFilterChange,
  onRefresh,
  onAddService,
  onEditService,
  onDeleteService,
  onToggleService,
}) {
  return (
    <div>
      {/* Title + Refresh now live in AdminDashboardPage's top header. Add
          Service lives inline with the filter row below so the action sits
          next to the filters it pairs with. */}

      {/* Filters + Add Service */}
      <div className="flex flex-col lg:flex-row gap-4 mb-4">
        <div className="flex-1">
          <div className="relative">
            <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#7a7060]" />
            <input
              type="text"
              placeholder="Search services..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border rounded-lg text-[13px] outline-none transition-shadow focus:shadow-sm focus:border-[#145f5f40]"
              style={{ borderColor: '#e8e2d6' }}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <select
            value={categoryFilter}
            onChange={(e) => onCategoryFilterChange(e.target.value)}
            className="px-4 py-2 border rounded-lg text-[13px] transition-colors hover:border-[#b8b0a0]"
            style={{ borderColor: '#e8e2d6' }}
          >
            <option value="all">All Categories</option>
            <option value="document_processing">Document Processing</option>
            <option value="filing">Filing</option>
            <option value="compliance">Compliance</option>
          </select>

          <Button onClick={onAddService} leftIcon={<FiPlus />} className="whitespace-nowrap">
            Add Service
          </Button>
        </div>
      </div>

      {/* Services Grid */}
      {loading ? (
        <div className="text-center py-20 text-[#7a7060]">
          <div className="animate-pulse">Loading services…</div>
        </div>
      ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {services.map((service) => (
          <div
            key={service._id}
            className="bg-white rounded-[12px] border p-4 transition-all duration-200 hover:-translate-y-[2px]"
            style={{ borderColor: '#ddd6c6', borderTop: '3px solid #145f5f', boxShadow: '0 2px 16px rgba(8,17,31,.07)' }}
            onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 6px 24px rgba(20,95,95,.12)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 2px 16px rgba(8,17,31,.07)'; }}
          >
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="text-[15px] font-bold text-[#08111f] leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{service.name}</h3>
                <p className="text-[11px] text-[#7a7060] mt-1">{service.description}</p>
              </div>
              <div className="flex gap-1">
                <Button variant="ghost" size="sm" iconOnly title="Edit" onClick={() => onEditService(service)}>
                  <FiEdit className="text-[12px]" />
                </Button>
                {onToggleService && (
                  <Button variant="ghost" size="sm" iconOnly title="Toggle Status" onClick={() => onToggleService(service._id)}>
                    <FiPower className={`text-[12px] ${service.isActive ? 'text-[#4a6b3f]' : 'text-[#7a7060]'}`} />
                  </Button>
                )}
                {onDeleteService && (
                  <Button variant="ghost" size="sm" iconOnly title="Delete" onClick={() => onDeleteService(service._id)}>
                    <FiTrash2 className="text-[12px]" style={{ color: '#9a564a' }} />
                  </Button>
                )}
              </div>
            </div>

            <div className="flex items-center justify-between text-[11px]">
              <span className="px-2 py-0.5 rounded-full text-[#145f5f]" style={{ background: '#145f5f22' }}>
                {service.category?.replace(/_/g, ' ')}
              </span>
              <span className="font-semibold text-[#08111f]">&#8377;{service.price}</span>
            </div>

            <div className="mt-3 flex items-center justify-between">
              <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${service.isActive ? 'bg-[#e8efe5] text-[#4a6b3f]' : 'bg-[#f2e9e6] text-[#9a564a]'}`}>
                {service.isActive ? 'Active' : 'Inactive'}
              </span>
              {service.estimatedTime && (
                <span className="text-[10px] text-[#7a7060]">Est: {service.estimatedTime}</span>
              )}
            </div>
          </div>
        ))}

        {services.length === 0 && (
          <div className="col-span-full text-center py-12 text-[#7a7060]">
            No services found
          </div>
        )}
      </div>
      )}
    </div>
  );
}

export default ServicesTab;
